export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-photos-e520f732a1b8f8b8f07c410168c18452.png";